// @file Vuex Store for showing Alert Dialog (e.g. when user is over the file size quota)
import { Module } from 'vuex'

interface AlertDialogPayload {
  iconSrc?: string | null
  iconAlt?: string | null
  title?: string
  body?: string
  closeButtonText?: string
  shouldFadeIn?: boolean
}

interface AlertDialogState extends Required<AlertDialogPayload> {
  isOpen: boolean
}

const blankState = (): AlertDialogState => ({
  isOpen: false,

  iconSrc: null,
  iconAlt: null,
  title: '',
  body: '',
  closeButtonText: '',
  shouldFadeIn: false,
})

const AlertDialogModule: Module<AlertDialogState, object> = {
  namespaced: true,
  state: blankState,
  mutations: {
    RESET_ALERT_DIALOG(state): void {
      Object.assign(state, blankState())
    },
    OPEN_ALERT_DIALOG(state, dialogState: Partial<AlertDialogState>): void {
      Object.assign(state, dialogState)
      state.isOpen = true
    },
  },
  actions: {
    openAlertDialog({ commit }, params: AlertDialogPayload): void {
      commit('OPEN_ALERT_DIALOG', params)
    },
    close({ commit }): void {
      commit('RESET_ALERT_DIALOG')
    },
  },
}

export default AlertDialogModule
export { AlertDialogState, AlertDialogPayload }
